export const API_ANNOUNCEMENTS_REQUEST = 'API_ANNOUNCEMENTS_REQUEST';
export const API_ANNOUNCEMENTS_SUCCESS = 'API_ANNOUNCEMENTS_SUCCESS';
export const API_ANNOUNCEMENTS_FAILURE = 'API_ANNOUNCEMENTS_FAILURE';
export const RESET_ANNOUNCEMENTS = 'RESET_ANNOUNCEMENTS';

export const announcementsRequest = () => ({
  type: API_ANNOUNCEMENTS_REQUEST,
});

export const announcementsSuccess = payload => ({
  type: API_ANNOUNCEMENTS_SUCCESS,
  payload,
});

export const announcementsFailure = payload => ({
  type: API_ANNOUNCEMENTS_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  announcements: null,
};

export function announcementsReducer(state = initialState, action) {
  switch (action.type) {
  
    case API_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        announcements: action.payload,
      };
    case API_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
      };
    default:
      return state;
  }
}
